import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import {Link} from "react-router-dom";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";
import HomeLogoLink from "../../Components/Common/HomeLogoLink";
import StatusOrders, { StatusOrdersHandle } from "./StatusOrders";
import { ORDER_STATUS_LABELS } from "../../constants/orderMappings";

const order_tab = [
    {
        key: "placed",
        title: ORDER_STATUS_LABELS.placed.toUpperCase(),
    },
    {
        key: "confirmed_preparing",
        title: ORDER_STATUS_LABELS.confirmed.toUpperCase(),
    },
    {
        key: "served",
        title: ORDER_STATUS_LABELS.served.toUpperCase(),
    },
    {
        key: "completed",
        title: ORDER_STATUS_LABELS.completed.toUpperCase(),
    },
    {
        key: "cancelled",
        title: ORDER_STATUS_LABELS.cancelled.toUpperCase(),
    }
];

const Order: React.FC = () => {
    const [currentTab, setCurrentTab] = React.useState("placed");
    const currentOrdersRef = React.useRef<StatusOrdersHandle>(null);

    const handleReloadTab = () => {
        currentOrdersRef.current?.reload();
    };
    const renderOrder = () => {
        switch (currentTab) {
            case "placed":
                return (
                    <StatusOrders
                        ref={currentOrdersRef}
                        status="placed"
                        sortBy="opened_at"
                        emptyMessage="Không có đơn hàng chờ xác nhận."
                    />
                );
            case "confirmed_preparing":
                return (
                    <StatusOrders
                        ref={currentOrdersRef}
                        status={["confirmed", "preparing"]}
                        sortBy="confirmed_at"
                        emptyMessage="Không có đơn hàng đang chờ làm món."
                    />
                );
            case "served":
                return (
                    <StatusOrders
                        ref={currentOrdersRef}
                        status="served"
                        sortBy="served_at"
                        emptyMessage="Không có đơn hàng sẵn sàng giao."
                    />
                );
            case "completed":
                return (
                    <StatusOrders
                        ref={currentOrdersRef}
                        status="completed"
                        sortBy="closed_at"
                        emptyMessage="Không có đơn hàng đã hoàn thành."
                    />
                );
            case "cancelled":
                return (
                    <StatusOrders
                        ref={currentOrdersRef}
                        status="cancelled"
                        sortBy="closed_at"
                        emptyMessage="Không có đơn hàng bị hủy."
                    />
                );
            default:
                return (
                    <StatusOrders
                        ref={currentOrdersRef}
                        status="placed"
                        sortBy="opened_at"
                        emptyMessage="Không có đơn hàng chờ xác nhận."
                    />
                );
        }
    }

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                    <HomeLogoLink className="me-2" />

                    <div className="page-heading">
                        <h6 className="mb-0">Danh sách đơn</h6>
                    </div>

                    <div className="d-flex align-items-center">
                        <div className="filter-option">
                            <i
                                className="mdi mdi-refresh"
                                role="button"
                                aria-label="Tải lại tab"
                                onClick={handleReloadTab}
                            ></i>
                        </div>
                        <HeaderSidebarToggle className="ms-2" />
                    </div>
                </div>
            </div>

            <div className="page-content-wrapper position-relative">
                <div className="py-3 position-sticky top-3125-rem z-2 bg-white border-top">
                    <div className="container">
                        <div className="row g-1 align-items-center rtl-flex-d-row-r">
                            <div className="col-12">
                                <Swiper
                                    loop={false}
                                    slidesPerView={2.5}
                                    spaceBetween={5}
                                    className="order-catagories owl-carousel py-1"
                                    slideToClickedSlide={true}
                                >
                                    {order_tab.map((item, i) => (
                                        <SwiperSlide
                                            key={i}
                                            className={currentTab === item.key ? "active" : ""}
                                        >
                                            <Link
                                                className="shadow-sm"
                                                to="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentTab(item.key);
                                                }}
                                            >
                                                {item.title}
                                            </Link>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-3">
                    <div className="container">
                        <div className="content">
                            {renderOrder()}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Order;
